import React from 'react';

import Button from 'react-bootstrap/Button';


class LockButton extends React.Component {
  render() {
    var variant = 'primary';
    var title = this.props.children;

    if (this.props.locked) {
      variant = 'locked btn-primary';
      // title = this.props.membershipLevel;
    }

    var buttonProps = {
      variant: variant
    };

    if (this.props.href) {
      buttonProps.href = this.props.href;
    }
    if (this.props.onClick) {
      buttonProps.onClick = this.props.onClick;
    }

    return (
      <Button {...buttonProps}>
        {title}
      </Button>
    );
  }
}


export default LockButton;

